import { useStyles, TextField, combine, linkpickTheme } from '@webapps/styles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import PropTypes from 'prop-types';

const mailSchema = yup.object().shape({
  email: yup.string().email('E-mail Invalide').required('* Requis'),
});

export default function MailConfirmation({ onSubmit, setMailConfirmationSubmit }) {
  const { classes } = useStyles(styles);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: mailSchema,
    onSubmit: async ({ email }) => {
      console.log("🚀 ~ Mail confirmation submit ~ email:", email);
      if (onSubmit) {
        await onSubmit(email);
      }
    },
  });

  // Exposer la fonction handleSubmit au parent
  if (setMailConfirmationSubmit) {
    setMailConfirmationSubmit(() => formik.handleSubmit);
  }

  return (
    <div className={classes.container}>
      <div className={classes.field}>
        <div className={classes.label}>Adresse email</div>
        <TextField
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          style={{ width: '100%', maxWidth: '100%' }}
        />
        {formik.touched.email && formik.errors.email ? (
          <div className={classes.error}>{formik.errors.email}</div>
        ) : null}
      </div>
    </div>
  );
}

MailConfirmation.propTypes = {
  onSubmit: PropTypes.func,
  setMailConfirmationSubmit: PropTypes.func,
};

const styles = () => {
  const { fontSizes2, colors, gap } = linkpickTheme.params;

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    field: {
      ...combine(gap.xs),
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    label: {
      ...combine(fontSizes2.body),
      fontFamily: '"Roboto", sans-serif',
      color: colors.blancGlacier,
    },
    error: {
      ...combine(fontSizes2.body),
      fontFamily: '"Roboto", sans-serif',
      color: colors.roseElectrique,
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      maxWidth: '100%',
      overflow: 'hidden',
    },
  };
}; 